import { getAPI, postAPI, deleteAPI, patchAPI } from "utils/http";
import { apis } from "config/urls";

export async function fetchExternalRoles({ token }) {
  const response = await getAPI(apis.externalRolesAPI, {}, token);
  const { data: res, status } = response;
  if (status === 200) {
    return res;
  }
  throw new Error("Failed to fetch external roles", { cause: response });
}

export async function fetchExternalPermissions({ token, roleName }) {
  const response = await getAPI(
    apis.externalPermissionsAPI(roleName),
    {},
    token
  );
  return response.data;
}
export async function fetchAllExternalPermissions({ token }) {
  const response = await getAPI(apis.getExternalPermissionsAPI, {}, token);
  return response.data;
}

export async function createExternalRole({
  token,
  role,
  rolePermissions,
  userEmail,
}) {
  const payload = {
    userEmail,
    role,
    rolePermissions,
  };
  const { data, status } = await postAPI(apis.externalRolesAPI, payload, token);
  if (status === 201) {
    return data;
  }
  throw new Error("Failed to create role", { cause: data });
}
export async function updateExternalRole({ token, role, rolePermissions }) {
  const payload = {
    role,
    rolePermissions,
  };
  const { data, status } = await patchAPI(
    apis.externalRolesAPI,
    payload,
    token
  );
  if (status === 200) {
    return data;
  }
  throw new Error("Failed to update role", { cause: data });
}

export async function deleteExternalRole({ token, roleId }) {
  const { data, status } = await deleteAPI(
    `${apis.externalRolesAPI}/${roleId}`,
    {},
    token
  );
  if (status === 200) {
    return data;
  }
  throw new Error("Failed to delete role", { cause: data });
}

export function permissionScopeToIdMapping(externalPermissions) {
  const mapping = {};
  externalPermissions.forEach((permission) => {
    mapping[permission.scope] = permission.id;
  });
  return mapping;
}

export async function assignPermissionsToRole({ token, permission }) {
  const payload = {
    roleName: permission.roleName,
    permissionId: permission.id,
    permissionAssigned: permission.scope,
  };
  const response = await postAPI(
    apis.externalPermissionsAPI(payload.roleName),
    payload,
    token
  );
  return response.data;
}

export async function unAssignPermissionsToRole({
  token,
  permissionName,
  roleName,
}) {
  const queryParams = `&permissionName=${encodeURIComponent(permissionName)}`;

  const response = await deleteAPI(
    apis.externalPermissionsAPI(roleName) + queryParams,
    {},
    token
  );
  return response.data;
}

export async function getRoleById({ token, roleId }) {
  const URL = apis.getRoleById(roleId);
  const response = await getAPI(URL, {}, token);
  const { data, status } = response;
  if (status === 200) {
    return data;
  }
  throw new Error("Failed to fetch role by ID", { cause: response });
}
